import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function LegalNotice() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <SEO
        title="TransCirox – Impressum | Rechtliche Angaben"
        description="Impressum der TransCiroX GmbH – Rechtliche Angaben gemäß § 5 TMG und § 18 Abs. 2 MStV."
        keywords="Impressum, TransCiroX, Rechtliche Angaben, Kontakt, Geschäftsführung"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("legal.hero.title")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>{t("legal.title.impressum")}</h1>

                {/* Company */}
                <div className="document-section">
                  <h3>{t("legal.company_name")}</h3>
                  <p>
                    {t("legal.company_address")}
                  </p>
                </div>

                <hr />

                {/* Management */}
                <div className="document-section">
                  <h3>{t("legal.manager_label")}</h3>
                  <p>{t("legal.manager_name")}</p>
                </div>

                <hr />

                {/* Contact */}
                <div className="document-section">
                  <h3>{t("legal.contact_label")}</h3>
                  <p>
                    <strong>{t("legal.phone_label")}:</strong> {t("legal.phone")}
                  </p>
                  <p>
                    <strong>{t("legal.email_label")}:</strong> <a href="mailto:kontakt@transcirox.com">{t("legal.email")}</a>
                  </p>
                  <p>
                    <strong>{t("legal.website_label")}:</strong> <a href="https://www.transcirox.com">www.transcirox.com</a>
                  </p>
                </div>

                <hr />

                {/* Commercial Register */}
                <div className="document-section">
                  <h3>{t("legal.commercial_register_label")}</h3>
                  <p>
                    <strong>{t("legal.register_court_label")}:</strong> {t("legal.register_court")}
                  </p>
                  <p>
                    <strong>{t("legal.register_number_label")}:</strong> {t("legal.register_number")}
                  </p>
                </div>

                <hr />

                {/* VAT ID */}
                <div className="document-section">
                  <h3>{t("legal.vat_id_label")}</h3>
                  <p>
                    <strong>{t("legal.USt_IdNr")}:</strong> {t("legal.vat_id")}
                  </p>
                </div>

                <hr />

                {/* Responsible for Content */}
                <div className="document-section">
                  <h3>{t("legal.responsible_label")}</h3>
                  <p>
                    {t("legal.responsible_name1")}
                    <br/>
                    {t("legal.responsible_name2")}
                  </p>
                  <p>{t("legal.responsible_company")}</p>
                  <p>{t("legal.responsible_address")}</p>
                </div>

                <hr />

                {/* Dispute Resolution */}
                <div className="document-section">
                  <h3>{t("legal.dispute_resolution_label")}</h3>
                  <p>{t("legal.dispute_resolution")}</p>
                </div>

                <hr />

                {/* Abuse */}
                {/* <div className="document-section">
                  <h3>{t("legal.abuse_title")}</h3>
                  <p>{t("legal.abuse_content_1")}</p>
                  <p>{t("legal.abuse_content_2")}</p>
                </div> */}

                {/* <hr /> */}

                {/* Footer */}
                <div className="document-meta">
                  <p>{t("legal.last_updated")}</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}